import * as actions from 'redux/actions/keywordFinder.actions'
import * as searchActions from 'redux/actions/search.actions'
import * as accountActions from 'redux/actions/account.actions'
import * as userActions from 'redux/actions/user.actions'

const initialState = {
  suggestions: null,
  suggestionsByDomain: null,
  searchId: null,
  loading: false,
  selection: [],
  serp: {},
  showResourcesError: false,
  previousResults: [],
  firstTimeSearch: true,
}

const updateSerp = (suggestions, payload) => {
  return suggestions.map(suggestion => {
    if (suggestion.uuid === payload.keywordId) {
      suggestion.difficulty = payload.difficulty
      suggestion.serp = payload.results
      suggestion.status = payload.inQueue ? null : 'completed'
    }

    return suggestion
  })
}

const keywordFinderReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.getKeywordFinderResults.type: {
      return {
        ...state,
        firstTimeSearch: false,
        loading: true
      }
    }
    case actions.getKeywordFinderKD.type: {
      const updatedSuggestions = state.suggestions.map(suggestion =>
        suggestion.uuid === payload.keywordId ? { ...suggestion, status: 'in_queue' } : suggestion
      )
      return {
        ...state,
        suggestions: updatedSuggestions,
      }
    }
    case actions.loadPreviousFailure.type:
    case actions.getKeywordFinderSuggestionsFailure.type:
    case actions.getKeywordFinderDomainFailure.type:
      return {
        ...state,
        loading: false,
        suggestions: null
      }
    case actions.getKeywordFinderKDFailure.type:
      return {
        ...state,
        loading: false,
        showResourcesError: payload.error.status === 422,
        suggestions: state.suggestions.map(suggestion =>
          suggestion.uuid === payload.keywordId
            ? {
              ...suggestion,
              status: 'complete'
            }
            : suggestion
        )
      }
    case actions.loadPreviousSuccess.type:
    case actions.getKeywordFinderSuggestionsSuccess.type:
    case actions.getKeywordFinderSuggestionsPartialSuccess.type:
      return {
        ...state,
        firstTimeSearch: false,
        suggestions: payload.data.attributes.results.map(item => {
          return {
            ...item,
            status: item.status === 'in_queue' ? null : item.status
          }
        }),
        searchId: payload.data.id,
        loading: false
      }
    case actions.getKeywordFinderDomain.type:
      return {
        ...state,
        loading: true
      }
    case actions.getKeywordFinderDomainSuccess.type:
      return {
        ...state,
        suggestions: payload.data.attributes.results.map(item => {
          return {
            ...item,
            status: item.status === 'in_queue' ? null : item.status
          }
        }),
        searchId: payload.data.id,
        loading: false
      }
    case actions.getKeywordFinderKDSuccess.type:
      return {
        ...state,
        suggestions: [...new Set([...updateSerp(state.suggestions, payload)])],
        loading: false
      }
    case actions.getKeywordFinderSERP.type:
      return {
        ...state,
        serp: {
          [payload.keywordId]: {
            ...state[payload.keywordId],
            loading: true,
            resourceError: false
          }
        }
      }
    case actions.getKeywordFinderSERPFailure.type:
      return {
        ...state,
        showResourcesError: payload.error.status === 422,
        serp: {
          [payload.keywordId]: {
            ...state[payload.keywordId],
            loading: false,
            resourceError: payload.error.status === 422
          }
        }
      }
    case actions.getKeywordFinderSERPSuccess.type:
      return {
        ...state,
        serp: {
          [payload.keywordId]: {
            ...state[payload.keywordId],
            results: payload.results,
            loading: false,
            resourceError: false
          }
        }
      }

    case actions.getKeywordFinderHistorySuccess.type:
      return {
        ...state,
        previousResults: payload.data?.length
          ? payload.data.sort((a, b) => (a.attributes.createdAt > b.attributes.createdAt ? -1 : 1))
          : []
      }
    case actions.getKeywordSuggestionsByDomainSuccess.type:
      return {
        ...state,
        suggestionsByDomain: payload.data,
        loading: false
      }
    case actions.resetKeywordSuggestionsByDomain.type:
      return {
        ...state,
        suggestionsByDomain: null,
        loading: true
      }
    case actions.getKeywordSuggestionsByDomainFailure.type:
      return {
        loading: false
      }
    case actions.showResourcesError.type:
      return {
        ...state,
        showResourcesError: false
      }
    case searchActions.setType.type: {
      return {
        ...state,
        firstTimeSearch: true
      }
    }
    case actions.addKeywordsToList.type: {
      return {
        ...state,
        firstTimeSearch: true,
        selection: payload.selection
      }
    }
    case actions.loadPrevious.type: {
      return {
        ...state,
        showHistoryModal: false,
        showListModal: false,
        firstTimeSearch: false
      }
    }
    case actions.deleteKeywords.type: {
      return {
        ...state,
        previousResults: state.previousResults.filter(history => payload.historyId !== history.id)
      }
    }

    case 'ROUTE_CHANGE':
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
      return {
        ...initialState,
        previousResults: [...state.previousResults]
      }
    default:
      return state
  }
}
export default keywordFinderReducer
